<template>
    <v-dialog v-model="dialog" width="500" scrollable>
        <template v-slot:activator="{ on }">
            <v-btn color="primary" v-on="on">Новый сценарий</v-btn>
        </template>

        <v-card class="pa-2">
            <v-card-title class="pa-0 pl-1 pb-5 text-left font-weight-medium" primary-title>Номер:</v-card-title>
            <v-card-text class="pa-0 px-3 text-left">
                <v-text-field
                        v-model="context"
                        :error-messages="contextErrors"
                        :counter="40"
                        label="Context"
                        required
                        @input="$v.context.$touch()"
                        @blur="$v.context.$touch()"

                        color="secondary"
                        class="pa-0 ma-0 my-2"

                />
                <v-text-field
                        v-model="exten"
                        :error-messages="extenErrors"
                        :counter="40"
                        label="Exten"
                        required
                        @input="$v.exten.$touch()"
                        @blur="$v.exten.$touch()"

                        color="secondary"
                        class="pa-0 ma-0 my-2"
                />
                <v-text-field
                        v-model="priority"
                        label="Priority"
                        max="999"
                        min="1"
                        step="1"
                        type="number"

                        color="secondary"
                        class="pa-0 ma-0 my-2"
                />
                <v-text-field
                        v-model="app"
                        :error-messages="appErrors"
                        :counter="40"
                        label="App"
                        required
                        @input="$v.app.$touch()"
                        @blur="$v.app.$touch()"
                />
                <v-text-field
                        v-model="appdata"
                        :error-messages="appdataErrors"
                        :counter="256"
                        label="Appdata"
                        required
                        @input="$v.appdata.$touch()"
                        @blur="$v.appdata.$touch()"
                />
            </v-card-text>

            <v-card-actions class="buttons-group justify-end pa-0 pt-3">
                <v-btn
                        class="primary text--darken-4 py-2 px-4"
                        small
                        height="auto"
                        dark
                        @click="deleteExtension()"
                >Удалить
                </v-btn>
                <v-btn
                        class="primary text--darken-4 py-2 px-4"
                        small
                        height="auto"
                        dark
                        @click="close()"
                >Закрыть
                </v-btn>
                <v-btn
                        class="primary text--darken-4 py-2 px-4"
                        small
                        height="auto"
                        dark
                        @click="save()"
                >Сохранить
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    import axios from 'axios'
    import { validationMixin } from 'vuelidate'
    import { required, maxLength } from 'vuelidate/lib/validators'

    export default {
        name: 'GeneralModal',

        mixins: [validationMixin],

        validations: {
            context: {required, maxLength: maxLength(40)},
            exten: {required, maxLength: maxLength(40)},
            app: {required, maxLength: maxLength(40)},
            appdata: {required, maxLength: maxLength(256)},
        },

        props: {
            object_id: {
                default: -1,
            },
        },

        data: () => ({
            dialog: false,

            id_extension: 0,
            context: '',
            exten: '',
            priority: 1,
            app: '',
            appdata: '',
        }),

        watch: {
            object_id: function () {
                console.log('watch(): ' + this.object_id)

                if (this.object_id > 0){
                    this.id_extension = this.object_id
                    this.getExtension(this.id_extension)
                }
            },
        },

        computed: {
            contextErrors() {
                const errors = [];
                if (!this.$v.context.$dirty) return errors;
                !this.$v.context.maxLength && errors.push('Context must be at most 40 characters long');
                !this.$v.context.required && errors.push('Context is required.');
                return errors;
            },
            extenErrors() {
                const errors = [];
                if (!this.$v.exten.$dirty) return errors;
                !this.$v.exten.maxLength && errors.push('Exten must be at most 40 characters long');
                !this.$v.exten.required && errors.push('Exten is required.');
                return errors;
            },
            appErrors() {
                const errors = [];
                if (!this.$v.app.$dirty) return errors;
                !this.$v.app.maxLength && errors.push('App must be at most 40 characters long');
                !this.$v.app.required && errors.push('App is required.');
                return errors;
            },
            appdataErrors() {
                const errors = [];
                if (!this.$v.appdata.$dirty) return errors;
                !this.$v.appdata.maxLength && errors.push('Appdata must be at most 256 characters long');
                !this.$v.appdata.required && errors.push('Appdata is required.');
                return errors;
            },
        },

        methods: {
            /**
             * Получить сценарий для редактирования.
             *
             * @param id_extension
             */
            getExtension(id_extension) {
                axios({
                    method: 'get',
                    url: process.env.VUE_APP_API_URL_PHONE + 'get-extension',
                    params: {
                        id_extension: id_extension
                    },
                }).then((response) => {

                    //console.log(response.data);

                    this.id_extension = response.data.id;
                    this.context = response.data.context;
                    this.exten = response.data.exten;
                    this.priority = response.data.priority;
                    this.app = response.data.app;
                    this.appdata = response.data.appdata;

                }).catch(error => alert(error));

                this.dialog = true
            },

            /**
             * Удалить сценарий.
             */
            deleteExtension() {

                axios({
                    method: 'post',
                    url: process.env.VUE_APP_API_URL_PHONE + 'delete-extension',
                    params: {
                        id_extension: this.id_extension,
                    },
                }).then((response) => {
                    console.log(response.data);
                }).catch(error => alert(error));

                this.close()
            },

            /**
             *  Сохранить сценарий.
             */
            save() {
                this.$v.$touch();

                if (!this.$v.$invalid) {

                    axios({
                        method: 'post',
                        url: process.env.VUE_APP_API_URL_PHONE + 'set-extension',
                        params: {
                            id_extension: this.id_extension,
                            context: this.context,
                            exten: this.exten,
                            priority: this.priority,
                            app: this.app,
                            appdata: this.appdata,
                        },
                    }).then((response) => {
                        console.log(response.data);
                    }).catch(error => alert(error));

                    this.close();
                }
            },

            /**
             * Закрыть модальное окно для редактирования сценария и обнулить поля.
             */
            close() {
                this.dialog = false;

                this.$v.$reset();
                this.id_extension = 0;
                this.context = '';
                this.exten = '';
                this.priority = 1;
                this.app = '';
                this.appdata = '';

                this.$emit('closeModal');
            },
        },
    }

</script>

<style scoped>
</style>
